// Auto-generated - DO NOT EDIT
import { addCollection } from '@iconify/react';

let iconsLoaded = false;
let loadingPromise: Promise<void> | null = null;

export async function preloadIcons(): Promise<void> {
  if (iconsLoaded) return;
  if (loadingPromise) return loadingPromise;
  
  loadingPromise = (async () => {
    const { iconCollections } = await import('./iconData.generated');
    for (const collection of Object.values(iconCollections)) {
      addCollection(collection);
    }
    iconsLoaded = true;
  })();
  
  return loadingPromise;
}

export { USED_ICONS } from './iconData.generated';
